import { jsx } from 'react/jsx-runtime';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { descriptionStyle } from '../dialog.vanilla.mjs';

const Description = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      AlertDialogPrimitive.Description,
      {
        "data-scope": "dialog",
        "data-part": "description",
        ref,
        className: classNames(className, descriptionStyle),
        ...props
      }
    );
  }
);

export { Description };
//# sourceMappingURL=Description.mjs.map
